"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTypeIndexLogic = void 0;
var rdflib_1 = require("rdflib");
var debug = __importStar(require("../util/debug"));
var ns_1 = require("../util/ns");
var utils_1 = require("../util/utils");
function createTypeIndexLogic(store, authn, profileLogic, utilityLogic) {
    var ns = ns_1.ns;
    function getRegistrations(instance, theClass) {
        return store
            .each(undefined, ns.solid("instance"), instance)
            .filter(function (r) {
            return store.holds(r, ns.solid("forClass"), theClass);
        });
    }
    function loadTypeIndexesFor(user) {
        return __awaiter(this, void 0, void 0, function () {
            var profile, suggestion, publicTypeIndex, err_1, message, publicScopes, preferencesFile, err_2, privateScopes, suggestedPrivateTypeIndex, privateTypeIndex, _a, err_3, message, scopes, files, err_4;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!user)
                            throw new Error("loadTypeIndexesFor: No user given");
                        return [4 /*yield*/, profileLogic.loadProfile(user)];
                    case 1:
                        profile = _b.sent();
                        suggestion = suggestPublicTypeIndex(user);
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, utilityLogic.followOrCreateLink(user, ns.solid('publicTypeIndex'), suggestion, profile)];
                    case 3:
                        publicTypeIndex = _b.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        err_1 = _b.sent();
                        message = "User ".concat(user, " has no pointer in profile to publicTypeIndex file.");
                        debug.warn(message);
                        return [3 /*break*/, 5];
                    case 5:
                        publicScopes = publicTypeIndex ? [{ label: 'public', index: publicTypeIndex, agent: user }] : [];
                        _b.label = 6;
                    case 6:
                        _b.trys.push([6, 8, , 9]);
                        return [4 /*yield*/, profileLogic.silencedLoadPreferences(user)];
                    case 7:
                        preferencesFile = _b.sent();
                        return [3 /*break*/, 9];
                    case 8:
                        err_2 = _b.sent();
                        preferencesFile = null;
                        return [3 /*break*/, 9];
                    case 9:
                        if (!preferencesFile) return [3 /*break*/, 15];
                        suggestedPrivateTypeIndex = suggestPrivateTypeIndex(preferencesFile);
                        privateTypeIndex = void 0;
                        _b.label = 10;
                    case 10:
                        _b.trys.push([10, 13, , 14]);
                        _a = store.any(user, ns.solid('privateTypeIndex'), undefined, profile);
                        if (_a) return [3 /*break*/, 12];
                        return [4 /*yield*/, utilityLogic.followOrCreateLink(user, ns.solid('privateTypeIndex'), suggestedPrivateTypeIndex, preferencesFile)];
                    case 11:
                        _a = (_b.sent());
                        _b.label = 12;
                    case 12:
                        privateTypeIndex = _a;
                        return [3 /*break*/, 14];
                    case 13:
                        err_3 = _b.sent();
                        message = "User ".concat(user, " has no pointer in preference file to privateTypeIndex file.");
                        debug.warn(message);
                        return [3 /*break*/, 14];
                    case 14:
                        privateScopes = privateTypeIndex ? [{ label: 'private', index: privateTypeIndex, agent: user }] : [];
                        return [3 /*break*/, 16];
                    case 15:
                        privateScopes = [];
                        _b.label = 16;
                    case 16:
                        scopes = publicScopes.concat(privateScopes);
                        if (scopes.length === 0)
                            return [2 /*return*/, scopes];
                        files = scopes.map(function (scope) { return scope.index; });
                        _b.label = 17;
                    case 17:
                        _b.trys.push([17, 19, , 20]);
                        return [4 /*yield*/, store.fetcher.load(files)];
                    case 18:
                        _b.sent();
                        return [3 /*break*/, 20];
                    case 19:
                        err_4 = _b.sent();
                        debug.warn('Problems loading type index: ', err_4);
                        return [3 /*break*/, 20];
                    case 20: return [2 /*return*/, scopes];
                }
            });
        });
    }
    function loadCommunityTypeIndexes(user) {
        return __awaiter(this, void 0, void 0, function () {
            var preferencesFile, err_5, message, communities, result, _i, communities_1, org, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, profileLogic.silencedLoadPreferences(user)];
                    case 1:
                        preferencesFile = _c.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        err_5 = _c.sent();
                        message = "User ".concat(user, " has no pointer in profile to preferences file.");
                        debug.warn(message);
                        return [3 /*break*/, 3];
                    case 3:
                        if (!preferencesFile) return [3 /*break*/, 8];
                        communities = store.each(user, ns.solid('community'), undefined, preferencesFile).concat(store.each(user, ns.solid('community'), undefined, user.doc()));
                        result = [];
                        _i = 0, communities_1 = communities;
                        _c.label = 4;
                    case 4:
                        if (!(_i < communities_1.length)) return [3 /*break*/, 7];
                        org = communities_1[_i];
                        _b = (_a = result).concat;
                        return [4 /*yield*/, loadTypeIndexesFor(org)];
                    case 5:
                        result = _b.apply(_a, [_c.sent()]);
                        _c.label = 6;
                    case 6:
                        _i++;
                        return [3 /*break*/, 4];
                    case 7: return [2 /*return*/, result];
                    case 8: return [2 /*return*/, []]; // No communities
                }
            });
        });
    }
    function loadAllTypeIndexes(user) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, loadTypeIndexesFor(user)];
                    case 1:
                        _b = (_a = (_c.sent())).concat;
                        return [4 /*yield*/, loadCommunityTypeIndexes(user)];
                    case 2: return [2 /*return*/, _b.apply(_a, [(_c.sent()).flat()])];
                }
            });
        });
    }
    function getScopedAppInstances(klass, user) {
        return __awaiter(this, void 0, void 0, function () {
            var scopes, scopedApps, _i, scopes_1, scope, scopedApps0;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, loadAllTypeIndexes(user)];
                    case 1:
                        scopes = _a.sent();
                        scopedApps = [];
                        _i = 0, scopes_1 = scopes;
                        _a.label = 2;
                    case 2:
                        if (!(_i < scopes_1.length)) return [3 /*break*/, 5];
                        scope = scopes_1[_i];
                        return [4 /*yield*/, getScopedAppsFromIndex(scope, klass)];
                    case 3:
                        scopedApps0 = _a.sent();
                        scopedApps = scopedApps.concat(scopedApps0);
                        _a.label = 4;
                    case 4:
                        _i++;
                        return [3 /*break*/, 2];
                    case 5: return [2 /*return*/, scopedApps];
                }
            });
        });
    }
    // This is the function signature which used to be in solid-ui/logic
    // Recommended to use getScopedAppInstances instead as it provides more information.
    //
    function getAppInstances(klass) {
        return __awaiter(this, void 0, void 0, function () {
            var user, scopedAppInstances;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        user = authn.currentUser();
                        if (!user)
                            throw new Error('getAppInstances: Must be logged in to find apps.');
                        return [4 /*yield*/, getScopedAppInstances(klass, user)];
                    case 1:
                        scopedAppInstances = _a.sent();
                        return [2 /*return*/, scopedAppInstances.map(function (scoped) { return scoped.instance; })];
                }
            });
        });
    }
    function suggestPublicTypeIndex(me) {
        var _a;
        return (0, rdflib_1.sym)(((_a = me.doc().dir()) === null || _a === void 0 ? void 0 : _a.uri) + 'publicTypeIndex.ttl');
    }
    // Note this one is based off the pref file not the profile
    function suggestPrivateTypeIndex(preferencesFile) {
        var _a;
        return (0, rdflib_1.sym)(((_a = preferencesFile.doc().dir()) === null || _a === void 0 ? void 0 : _a.uri) + 'privateTypeIndex.ttl');
    }
    /*
    * Register a new app in a type index
    * used in chat in bookmark.js (solid-ui)
    * Returns the registration object if successful else null
    */
    function registerInTypeIndex(instance, index, theClass) {
        return __awaiter(this, void 0, void 0, function () {
            var registration, ins, err_6, msg;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        registration = (0, utils_1.newThing)(index);
                        ins = [
                            // See https://github.com/solid/solid/blob/main/proposals/data-discovery.md
                            (0, rdflib_1.st)(registration, ns.rdf('type'), ns.solid('TypeRegistration'), index),
                            (0, rdflib_1.st)(registration, ns.solid('forClass'), theClass, index),
                            (0, rdflib_1.st)(registration, ns.solid('instance'), instance, index)
                        ];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, store.updater.update([], ins)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_6 = _a.sent();
                        msg = "Unable to register ".concat(instance, " in index ").concat(index, ": ").concat(err_6);
                        console.warn(msg);
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/, registration];
                }
            });
        });
    }
    function deleteTypeIndexRegistration(item) {
        return __awaiter(this, void 0, void 0, function () {
            var reg, statements;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        reg = store.the(null, ns.solid('instance'), item.instance, item.scope.index);
                        if (!reg)
                            throw new Error("deleteTypeIndexRegistration: No registration found for ".concat(item.instance));
                        statements = store.statementsMatching(reg, null, null, item.scope.index);
                        return [4 /*yield*/, store.updater.update(statements, [])];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    function getScopedAppsFromIndex(scope, theClass) {
        return __awaiter(this, void 0, void 0, function () {
            var index, registrations, relevant, directInstances, instances, instanceContainers, containers, i, cont, contents;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        index = scope.index;
                        registrations = store.statementsMatching(null, ns.solid('instance'), null, index)
                            .concat(store.statementsMatching(null, ns.solid('instanceContainer'), null, index))
                            .map(function (st) { return st.subject; });
                        relevant = theClass ? registrations.filter(function (reg) { var _a; return (_a = store.any(reg, ns.solid('forClass'), null, index)) === null || _a === void 0 ? void 0 : _a.sameTerm(theClass); })
                            : registrations;
                        directInstances = relevant.map(function (reg) { return store.each(reg, ns.solid('instance'), null, index).map(function (one) { return (0, rdflib_1.sym)(one.value); }); }).flat();
                        instances = (0, utils_1.uniqueNodes)(directInstances);
                        instanceContainers = relevant.map(function (reg) { return store.each(reg, ns.solid('instanceContainer'), null, index).map(function (one) { return (0, rdflib_1.sym)(one.value); }); }).flat();
                        containers = (0, utils_1.uniqueNodes)(instanceContainers);
                        if (containers.length > 0) {
                            console.log('@@ getScopedAppsFromIndex containers ', containers);
                        }
                        i = 0;
                        _a.label = 1;
                    case 1:
                        if (!(i < containers.length)) return [3 /*break*/, 4];
                        cont = containers[i];
                        return [4 /*yield*/, store.fetcher.load(cont)];
                    case 2:
                        _a.sent();
                        contents = store.each(cont, ns.ldp('contains'), null, cont).map(function (one) { return (0, rdflib_1.sym)(one.value); });
                        instances = instances.concat(contents);
                        _a.label = 3;
                    case 3:
                        i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/, instances.map(function (instance) { return { instance: instance, scope: scope }; })];
                }
            });
        });
    }
    return {
        registerInTypeIndex: registerInTypeIndex,
        getRegistrations: getRegistrations,
        loadTypeIndexesFor: loadTypeIndexesFor,
        loadCommunityTypeIndexes: loadCommunityTypeIndexes,
        loadAllTypeIndexes: loadAllTypeIndexes,
        getScopedAppInstances: getScopedAppInstances,
        getAppInstances: getAppInstances,
        suggestPublicTypeIndex: suggestPublicTypeIndex,
        suggestPrivateTypeIndex: suggestPrivateTypeIndex,
        deleteTypeIndexRegistration: deleteTypeIndexRegistration,
        getScopedAppsFromIndex: getScopedAppsFromIndex
    };
}
exports.createTypeIndexLogic = createTypeIndexLogic;
//# sourceMappingURL=typeIndexLogic.js.map